import { WindowIcon } from "components/atoms/Icon";
import { Header } from "components/atoms/Typography";
import { BuildingSectionProps, windowFieldValues } from "../BuildingConstruction.constants";
import BuildingSectionBody from "./BuildingSectionBody";

function BuildingWindows(props: BuildingSectionProps) {
    if (props.isEditing) return null;
    return (
        <>
            {!props.isEditing && (
                <div className="construction-sidebar__body__header">
                    <WindowIcon />
                    <Header size="medium">Window</Header>
                </div>
            )}
            <BuildingSectionBody {...props} fields={windowFieldValues} />
        </>
    );
}

export default BuildingWindows;
